import { z } from 'zod';

import { postToApi } from './apiClient';

const LOGIN_URL = '/v1/api/login';
const FORGOT_PASSWORD_URL = '/v1/api/forgot-password';
const LOGOUT_URL = '/v1/api/logout';

const LoginResponseSchema = z.object({
  authorization: z.string(),
  status: z.string(),
});

const ForgotPasswordResponseSchema = z.object({
  message: z.string(),
});

const userLogin = async (data: { email: string; password: string }) => {
  const response = await postToApi(LOGIN_URL, data);
  const parsedResponse = LoginResponseSchema.parse(response.data);
  return parsedResponse;
};

const forgotPassword = async (data: { email: string }) => {
  const response = await postToApi(FORGOT_PASSWORD_URL, {
    user_id: data.email,
  });
  const parsedResponse = ForgotPasswordResponseSchema.parse(response.data);
  return parsedResponse;
};

const userLogout = async () => {
  const response = await postToApi(LOGOUT_URL, {});
  return response;
};

export { forgotPassword, userLogin, userLogout };
